import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { reportPlay } from "../library/playtime";
import { queryKeys } from "../library/queries";
import { desktop } from "./desktop";
import { session } from "../auth/session";

/**
 * Play time for games in their own windows: the game process counts active
 * seconds and the app passes them on; this adds them to the signed-in
 * account, as the web player does for its own games.
 */
export default function DesktopPlaytime() {
  const queryClient = useQueryClient();
  useEffect(() => {
    let stop = () => {};
    desktop
      .onPlayed(({ name, system }, seconds) => {
        if (!session.bearer()) return;
        reportPlay(name, system, seconds)
          .then(() => [queryKeys.playtime, queryKeys.dashboard].forEach((queryKey) => queryClient.invalidateQueries({ queryKey })))
          .catch(() => {});
      })
      .then((unlisten) => {
        stop = unlisten;
      });
    return () => stop();
  }, [queryClient]);
  return null;
}
